import React from 'react'

const ROW_MINI_BAR_HEIGHT = 14

const MiniStackedBar = ({ segments, onClick }) => {
    const safeSegments = Array.isArray(segments) ? segments.filter(s => s.percent > 0) : []
    return (
        <div
            onClick={onClick}
            style={{
                display: 'flex',
                width: '100%',
                height: ROW_MINI_BAR_HEIGHT,
                borderRadius: 4,
                overflow: 'hidden',
                cursor: 'pointer',
                border: '1px solid #f0f0f0',
            }}
        >
            {safeSegments.map((seg, idx) => (
                <div
                    key={`${seg.categoryId}-${idx}`}
                    style={{
                        width: `${Math.max(0, Math.min(100, seg.percent))}%`,
                        backgroundColor: seg.color,
                        height: '100%',
                    }}
                    title={`${seg.categoryName}: ${seg.percent}%`}
                />
            ))}
        </div>
    )
}

export default MiniStackedBar


